import { apiClient, handleApiRequest } from './client'

export interface CalendarFeedStatus {
  enabled: boolean
  token: string | null
  feed_url: string | null
  last_accessed_at: string | null
  role: string
  machine_ip: string | null
  qr_url?: string | null
}

export interface CalendarFeedSubscribeResponse {
  token: string
  feed_url: string
  enabled: boolean
  machine_ip: string | null
  qr_url?: string | null
}

export interface CalendarExportStats {
  enabled: boolean
  include_requester: boolean
  days_ahead: number
  days_past: number
  subscription_count: number
  active_subscription_count: number
}

export interface CalendarFeedPreviewItem {
  entry_type: string
  role: string | null
  date_str: string | null
  start_time: string | null
  end_time: string | null
  subject_name: string | null
  klass_name: string | null
  room_name: string | null
  requester_name: string | null
  substitute_name: string | null
  cancelled: boolean
}

export interface CalendarFeedPreviewSettings {
  feed_include_substitutions: boolean
  feed_include_absences: boolean
  feed_include_cancelled: boolean
  feed_include_open_requests: boolean
  feed_show_subject: boolean
  feed_show_klass: boolean
  feed_show_room: boolean
  feed_show_teacher: boolean
  window_days_ahead?: number
  window_days_past?: number
}

export interface CalendarFeedPreviewResponse {
  entries: CalendarFeedPreviewItem[]
  settings: Partial<CalendarFeedPreviewSettings>
  status: 'ok' | 'no_subscription' | 'export_disabled' | string
}

export const calendarFeedApi = {
  getStatus: () =>
    handleApiRequest<CalendarFeedStatus>(
      apiClient.get('/api/v1/teacher/calendar-feed/status')
    ),

  subscribe: () =>
    handleApiRequest<CalendarFeedSubscribeResponse>(
      apiClient.post('/api/v1/teacher/calendar-feed/subscribe')
    ),

  resetToken: () =>
    handleApiRequest<CalendarFeedSubscribeResponse>(
      apiClient.post('/api/v1/teacher/calendar-feed/reset-token')
    ),

  toggle: (enabled: boolean) =>
    handleApiRequest<CalendarFeedStatus>(
      apiClient.put('/api/v1/teacher/calendar-feed/toggle', { enabled })
    ),

  getPreview: (settings?: Partial<CalendarFeedPreviewSettings>, limit = 5) => {
    const params = new URLSearchParams({ limit: String(limit) })
    if (settings) {
      if (typeof settings.feed_include_substitutions === 'boolean') params.set('feed_include_substitutions', String(settings.feed_include_substitutions))
      if (typeof settings.feed_include_absences === 'boolean') params.set('feed_include_absences', String(settings.feed_include_absences))
      if (typeof settings.feed_include_cancelled === 'boolean') params.set('feed_include_cancelled', String(settings.feed_include_cancelled))
      if (typeof settings.feed_include_open_requests === 'boolean') params.set('feed_include_open_requests', String(settings.feed_include_open_requests))
      if (typeof settings.feed_show_subject === 'boolean') params.set('feed_show_subject', String(settings.feed_show_subject))
      if (typeof settings.feed_show_klass === 'boolean') params.set('feed_show_klass', String(settings.feed_show_klass))
      if (typeof settings.feed_show_room === 'boolean') params.set('feed_show_room', String(settings.feed_show_room))
      if (typeof settings.feed_show_teacher === 'boolean') params.set('feed_show_teacher', String(settings.feed_show_teacher))
    }
    return handleApiRequest<CalendarFeedPreviewResponse>(
      apiClient.get(`/api/v1/teacher/calendar-feed/preview?${params.toString()}`)
    )
  },

  getAdminStats: () =>
    handleApiRequest<CalendarExportStats>(
      apiClient.get('/api/v1/superadmin/calendar-export/stats')
    ),

  toggleAdmin: (enabled: boolean) =>
    handleApiRequest<{ message: string }>(
      apiClient.put('/api/v1/superadmin/calendar-export/toggle', { enabled })
    ),
}